import { render, staticRenderFns } from "./ArchiveSummaryInfo.vue?vue&type=template&id=5f990b90&scoped=true&"
import script from "./ArchiveSummaryInfo.vue?vue&type=script&lang=js&"
export * from "./ArchiveSummaryInfo.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveSummaryInfo.vue?vue&type=style&index=0&id=5f990b90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f990b90",
  null
  
)

export default component.exports